var exports = {
  "k": "xdbfd91f1--289316--container",
  "j": "xdbfd91f1--289316--photo",
};

module.exports = exports;
